import { PayrollProviderName } from 'api/EmployersApi';
import { AtomicProductSupport, GetApplicationData } from 'handlers/applicationData';

export const hasAtomicProductSupport = (product: AtomicProductSupport, application?: GetApplicationData): boolean => {
  if (!application) return false;

  const employer1 = application?.employment.employer1;
  const { payrollProvider, supportedPayrollProducts } = employer1;

  if (payrollProvider === PayrollProviderName.Atomic && !supportedPayrollProducts?.includes(product)) {
    return false;
  }

  return true;
};
